import { render, staticRenderFns } from "./myBuyers.vue?vue&type=template&id=eb934c4a&scoped=true&lang=html&"
import script from "./myBuyers.vue?vue&type=script&lang=js&"
export * from "./myBuyers.vue?vue&type=script&lang=js&"
import style0 from "./myBuyers.vue?vue&type=style&index=0&id=eb934c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb934c4a",
  null
  
)

export default component.exports